<template>

    <div class="bracket-container stage-type--double">
        <div class="tournament-bracket">

            <template v-for="i in numRounds">
                <div class="tournament-bracket__round" v-for="c in 2">
                    <h3 class="tournament-bracket__round-title">Ronda {{(i*c)}}</h3>

                    <ul class="tournament-bracket__list">
                        <li class="tournament-bracket__item" v-bind:class="[bracketData.bracket[i-1][c][j-1]['type']==='none' ? 'game-type-none' : '']" v-for="j in getGamenum(i-1)">

                            <div class="tournament-bracket__match" v-if="bracketData.bracket[i-1][c][j-1]['type']==='none'">
                                <div class="widget-match-box bordered small">
                                    <div class="widget-team-vs small">
                                        <div class="widget-team-vs-item">
                                            <div class="team-info-wrap">
                                                <div class="team-info">
                                                    <p class="team-name"></p>
                                                    <p class="team-country"></p>
                                                </div>
                                            </div>
                                            <p class="team-score">3</p>
                                        </div>

                                        <div class="widget-team-vs-item">
                                            <div class="team-info-wrap">
                                                <div class="team-info">
                                                    <p class="team-name"></p>
                                                    <p class="team-country"></p>
                                                </div>
                                            </div>
                                            <p class="team-score light"></p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <SingleGame v-if="bracketData.bracket[i-1][c][j-1]['type']==='match'" :matchId="parseInt(bracketData.bracket[i-1][c][j-1]['match'])" :uidr="(i-1)+c+''+(j-1)"></SingleGame>

                        </li>
                    </ul>
                </div>
            </template>


        </div>
    </div>

</template>

<script>
    import SingleGame from "./SingleGame";
    export default {
        name: "LowerBracket",
        components: {SingleGame},
        props:{
            bracket: Object,
            id: Number,
        },
        data: function(){
            return {
                bracketData:null,
                numRounds:null,
                games:null,
                exp:2,
                count:0,
            }
        },
        created: function(){
            this.getData();
        },
        updated: function(){
            this.getData();
        },
        methods: {
            getData(){
                this.bracketData=this.$props.bracket;

                this.numRounds=Math.log2(this.bracketData.num_teams);
                this.games=this.bracketData.num_teams/2;

                console.log("Updated data");
            },
            getGamenum(index){
                return this.bracketData.num_teams/(Math.pow(2, index+1));
            }
        },

        watch: {
            id: function(newVal, oldVal) { // watch it

                if(newVal !== oldVal){
                    this.isLoading=true;
                    this.getData();
                }

            }
        }
    }
</script>

<style scoped>

    /*!
     * Responsive Tournament Bracket
     * Copyright 2016 Jakub Hájek
     * Licensed under MIT (https://opensource.org/licenses/MIT)
     */
    h1 {
        font-size: 28px;
    }

    h2 {
        font-size: 20px;
    }

    .bracket-container {
        background: transparent;
        overflow-x: auto;
        margin-top: 20px;
    }

    .tournament-bracket {
        display: flex;
        margin-bottom: 20px;
    }

    .tournament-bracket__round {
        display: flex;
        margin-left: -2px;
        flex-direction: column;
    }

    .tournament-bracket__round ul {
        padding: 0;
        margin: 0;
    }

    .tournament-bracket .tournament-bracket__round:first-of-type {
        margin-left: 0;
    }

    .tournament-bracket__round-title {
        color: #FFF;
        font-size: 16px;
        font-weight: 400;
        text-align: center;
        padding-bottom: 8px;
        margin: 10px 23px;
    }

    .tournament-bracket__list {
        display: flex;
        flex-wrap: wrap;
        height: 100%;
        padding-left: 0;
        width: 300px;
    }

    .tournament-bracket__round:last-child .tournament-bracket__list {
        border-right-width: 0;
    }

    .tournament-bracket__item {
        display: flex;
        justify-content: center;
        flex-direction: column;
        position: relative;
        padding: 0.5em 1.5em;
    }

    .match-id {
        align-self: flex-end;
        text-align: right;
        font-size: 12px;
    }

    .players {
        width: 100%;
        table-layout: fixed;
        cursor: pointer;
    }

    .match-extra {
        display: flex;
        align-items: center;
    }

    .match-extra--status {
        padding-left: 5px;
        display: flex;
        align-items: center;
        flex-grow: 1;
    }

    .match-extra--status span {
        display: inline-block;
        padding-right: 2px;
    }

    .players td {
        background-color: #f5f5f5;
        padding: 5px 10px;
        border: 2px solid #fff;
    }

    .match-game {
        margin-bottom: 20px;
        background-color: #f8f8f8;
        border-radius: 5px;
        padding: 10px;
    }

    .match-game .header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 5px;
    }

    .match-game .match-meta td {
        padding: 0 5px;
    }

    .match-game .match-meta td:first-child {
        padding-left: 0;
    }

    .match-game .match-meta td:last-child {
        padding-right: 0;
    }

    .match-game .admin-actions {
        padding-top: 10px;
    }

    .match-game .scores {
        margin-bottom: 0;
        background: #eee;
    }

    .match-game .scores  caption {
        color: #000;
    }

    .match-game .scores .score {
        width: 1%;
    }

    .no-teams {
        padding: 10px;
    }

    .players .seed {
        font-weight: bold;
        background-color: #DDD;
        text-align: center;
        border-left-width: 0;
        font-family: Courier, monospace;
        width: 3.5em;
    }

    .players .seed.outcome-1 {
        background-color: #ffbdbd;
    }

    .players .seed.outcome-2 {
        background-color: #fdfd96;
    }

    .players .seed.outcome-3 {
        background-color: #e1f7d5;
    }

    .players .name {
        border-right-width: 0;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .tournament-bracket__item::after {
        position: absolute;
        right: 0;
        content: '';
        display: block;
        width: 1.5em;
        height: 45%;
        border-right: 2px solid #34373f;
    }

    .tournament-bracket__item:nth-child(odd)::after {
        top: 50%;
        border-top: 2px solid #34373f;
        transform: translateY(-1px);
    }

    .tournament-bracket__item:nth-child(even)::after {
        bottom: 50%;
        border-bottom: 2px solid #34373f;
        transform: translateY(1px);
    }

    .tournament-bracket__round:last-child .tournament-bracket__item::after {
        display: none;
    }

    .tournament-bracket__match {
        display: block;
        width: 100%;
    }

    .tournament-bracket__match::before,
    .tournament-bracket__match::after {
        position: absolute;
        left: 0;
        z-index: 1;
        content: '';
        display: block;
        width: 1.5em;
        height: 10%;
        border-left: 2px solid #34373f;
    }

    .tournament-bracket__match::before {
        bottom: 50%;
        border-bottom: 2px solid #34373f;
        transform: translate(0, 1px);
    }

    .tournament-bracket__match::after {
        top: 50%;
        border-top: 2px solid #34373f;
        transform: translate(0, -1px);
    }

    .server-status {
        display: flex;
        justify-content: space-between;
        margin-left: 5px;
        text-align: right;
        cursor: pointer;
    }

    .tournament-bracket__player {
        display: flex;
        align-items: center;
    }

    .tournament-bracket__player td {
        background-color: #f5f5f5;
    }

    .tournament-bracket__player .seed {
        font-weight: 700;
        padding-right: 5px;
        background-color: #eee;
    }

    .tournament-bracket__round:first-child .tournament-bracket__match::before,
    .tournament-bracket__round:first-child .tournament-bracket__match::after {
        display: none;
    }


    /* double elimination overrides. */
    .stage-type--double .tournament-bracket__round:nth-last-child(2) .tournament-bracket__item::after {
        border-right-width: 0;
    }

    .stage-type--double .tournament-bracket__round:last-child .tournament-bracket__match:after  {
        border-left-width: 0;
    }
    .stage-type--double .tournament-bracket:last-child .tournament-bracket__round:nth-child(odd) .tournament-bracket__item::after {
        border-right-width: 0;
    }

    .stage-type--double .tournament-bracket:last-child .tournament-bracket__round:nth-child(even) .tournament-bracket__match::before,
    .stage-type--double .tournament-bracket:last-child .tournament-bracket__round:nth-child(even) .tournament-bracket__match::after {
        border-left-width: 0;
    }

    .stage-type--double .tournament-bracket__round:last-child .tournament-bracket__match:before  {
        display: none;
    }

    .tournament-bracket__item.game-type-none:nth-child(2n+1)::after {
        border-top: none;
    }

    .tournament-bracket__item.game-type-none::after {
        border-right: none;
    }

    .tournament-bracket__item.game-type-none:nth-child(2n)::after {
        border-bottom: none;
    }

    .tournament-bracket__item.game-type-none > .tournament-bracket__match {
        opacity:0;
    }


</style>